module.exports = __webpack_public_path__ + "static/media/united kingdom-01.873309d0.png";